var isInitialized = false;
var base = 10;

function update() {
  var _getComputedStyle = getComputedStyle(document.documentElement),
      fontSize = _getComputedStyle.fontSize;

  base = parseFloat(fontSize);
}

function init() {
  if (isInitialized) return;
  window.addEventListener('resize', update, {
    passive: true
  });
  update();
  isInitialized = true;
}

export default function rem(pxValue) {
  init();
  return pxValue * base * 0.1;
}